/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


